module.exports = __webpack_public_path__ + "media/images/result_sets/circles/3n4n6r9r-fe7d3d7967b80502005b1afb67fb2b18.svg";